"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileUpload = exports.useDeleteBulk = exports.useDelete = exports.useUpdateBulk = exports.useUpdate = exports.useEdit = exports.useSetHeader = exports.usePrepend = exports.useCreate = exports.useLoad = exports.useSearch = exports.useReset = exports.buildMessage = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var lodash_1 = require("lodash");
var util_1 = require("remota-common/util");
var object_1 = require("remota-client/util/object");
var multi_1 = require("remota-client/module/multi");
var loading_1 = require("./loading");
var notification_1 = require("./notification");
var action_1 = require("../module/multi/action");
var translate_1 = require("remota-common/util/translate");
var fat_1 = require("remota-common/util/fat");
var buildMessage = function (t, key, message) {
    var base = key.startsWith("fat:") ? (0, fat_1.deFat)(key) : t(key);
    if (!message) {
        return base;
    }
    var mes = t(message);
    return "".concat(base, " - ").concat(mes);
};
exports.buildMessage = buildMessage;
/**
 * リセットを仕様する。
 * 型パラメータは Module
 */
var useReset = function (module) {
    var dispatch = (0, react_redux_1.useDispatch)();
    return (0, react_1.useCallback)(function () {
        dispatch((0, multi_1.reset)(module));
    }, [module, dispatch]);
};
exports.useReset = useReset;
var searchSuccessMsgs = {};
var searchFailureMsgs = {
    enabledVoucherType: (0, translate_1.fat)("証憑種別の読み込みに失敗しました。"),
    enabledVoucherField: (0, translate_1.fat)("証憑項目一覧の読み込みに失敗しました。"),
    enabledFeature: (0, translate_1.fat)("機能の読み込みに失敗しました。"),
    enabledPartnerField: (0, translate_1.fat)("取引先項目の読み込みに失敗しました。"),
    format: (0, translate_1.fat)("出力フォーマット一覧の読み込みに失敗しました。"),
    formatTemplate: (0, translate_1.fat)("出力フォーマットテンプレート一覧の読み込みに失敗しました。"),
    job: (0, translate_1.fat)("ジョブ一覧の読み込みに失敗しました。"),
    jobLog: (0, translate_1.fat)("ジョブ実行ログ一覧の読み込みに失敗しました。"),
    loginLog: (0, translate_1.fat)("ログイン履歴の読み込みに失敗しました。"),
    list: (0, translate_1.fat)("Concurリストの取得に失敗しました。"),
    master: (0, translate_1.fat)("マスタ一覧の読み込みに失敗しました。"),
    master2: (0, translate_1.fat)("マスタ一覧の読み込みに失敗しました。"),
    modification: (0, translate_1.fat)("補正方法一覧の読み込みに失敗しました。"),
    partner: (0, translate_1.fat)("取引先一覧の読み込みに失敗しました。"),
    accountingType: (0, translate_1.fat)("勘定科目一覧の読み込みに失敗しました。"),
    taxDiv: (0, translate_1.fat)("税区分一覧の読み込みに失敗しました。"),
    recipient: (0, translate_1.fat)("宛名一覧の読み込みに失敗しました。"),
    ipRestriction: (0, translate_1.fat)("IP制限一覧の読み込みに失敗しました。"),
    role: (0, translate_1.fat)("ロール一覧の読み込みに失敗しました。"),
    rule: (0, translate_1.fat)("ルール一覧の読み込みに失敗しました。"),
    user: (0, translate_1.fat)("ユーザー一覧の読み込みに失敗しました。"),
    userMapping: (0, translate_1.fat)("ユーザ情報の読み込みに失敗しました。"),
    voucher: (0, translate_1.fat)("証憑一覧の読み込みに失敗しました。"),
    voucherMapping: (0, translate_1.fat)("入力設定一覧の読み込みに失敗しました。"),
    enabledAccountingTypeField: (0, translate_1.fat)("勘定科目項目の読み込みに失敗しました。"),
};
/**
 * 検索を使用する。
 * 型パラメータは Module, Header, Query, Item
 */
var useSearch = function (module, state, url, query, option) {
    var _a = option || {}, _b = _a.searchOnLoad, searchOnLoad = _b === void 0 ? true : _b, _c = _a.notifyOnSuccess, notifyOnSuccess = _c === void 0 ? false : _c, _d = _a.notificationSuccessKey, notificationSuccessKey = _d === void 0 ? searchSuccessMsgs["".concat(module)] || "" : _d, _e = _a.notifyOnFailure, notifyOnFailure = _e === void 0 ? true : _e, _f = _a.notificationFailureKey, notificationFailureKey = _f === void 0 ? searchFailureMsgs["".concat(module)] || "" : _f;
    var _g = __read((0, react_1.useState)(searchOnLoad), 2), isStarted = _g[0], setStarted = _g[1];
    var queryHash = (0, react_1.useMemo)(function () { return (0, object_1.getHash)([url, (0, lodash_1.omit)(query, "cursor")]); }, [url, query]);
    var _h = __read((0, react_i18next_1.useTranslation)(), 1), t = _h[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res) {
        if (notifyOnSuccess) {
            notify({ message: (0, exports.buildMessage)(t, notificationSuccessKey), severity: "success" });
        }
        setStarted(false);
        return (0, multi_1.setResult)(module, queryHash, res);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, queryHash, t]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: (0, exports.buildMessage)(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var _j = __read(getItems(state[0], queryHash), 2), items = _j[0], count = _j[1];
    var isInitialized = state[0].isInitializedMap[queryHash] || false;
    var nextCursor = state[0].cursorMap[queryHash];
    (0, react_1.useEffect)(function () {
        // query が変わった場合などに初期読み込みできるようにする
        if (!isStarted && searchOnLoad && nextCursor === undefined) {
            setStarted(true);
        }
    }, [isStarted, nextCursor, searchOnLoad]);
    var loadingStatus = (0, loading_1.useHttpGet)(state[1], url, (0, util_1.omitUndefined)(__assign(__assign({}, query), { cursor: nextCursor, t: state[0].resetAt })), isStarted && nextCursor !== null, resultToAction, errorToAction);
    var canSearchMore = isInitialized && !loadingStatus.isLoading && state[0].cursorMap[queryHash] !== null;
    var searchStatus = (0, react_1.useMemo)(function () { return (__assign(__assign({}, loadingStatus), { isInitialized: isInitialized, canSearchMore: canSearchMore })); }, [canSearchMore, isInitialized, loadingStatus]);
    var run = (0, react_1.useCallback)(function () {
        setStarted(true);
    }, [setStarted]);
    return (0, react_1.useMemo)(function () { return [items, count, searchStatus, run]; }, [count, items, run, searchStatus]);
};
exports.useSearch = useSearch;
function getItems(state, queryHash) {
    var ids = state.idsMap[queryHash];
    var count = state.countMap[queryHash];
    var enabledCount = state.enabledCountMap[queryHash];
    var newItems = state.newItems;
    if (!ids) {
        if (newItems.length === 0) {
            return [undefined, count, enabledCount];
        }
        else {
            return [newItems, count, enabledCount];
        }
    }
    var items = ids.map(function (id) { return state.headerMap[id]; });
    return [(0, lodash_1.uniqBy)(items.concat(newItems), function (item) { return item.id; }), count, enabledCount];
}
/**
 * 単体読み込みを使用する。
 * 型パラメータは Module, Header, Item
 */
var useLoad = function (module, state, url, id, option) {
    var loadSuccessMsgs = {};
    var loadFailureMsgs = {
        tenant: (0, translate_1.fat)("テナントの読み込みに失敗しました。"),
        profile: (0, translate_1.fat)("プロフィールの読み込みに失敗しました。"),
        voucherCount: (0, translate_1.fat)("証憑件数の読み込みに失敗しました。"),
        enabledFeature: (0, translate_1.fat)("機能の読み込みに失敗しました。"),
        enabledPartnerField: (0, translate_1.fat)("取引先項目の読み込みに失敗しました。"),
        enabledVoucherType: (0, translate_1.fat)("証憑種別の読み込みに失敗しました。"),
        enabledVoucherFieldList: (0, translate_1.fat)("証憑項目一覧の読み込みに失敗しました。"),
        enabledVoucherField: (0, translate_1.fat)("証憑項目の読み込みに失敗しました。"),
        formatList: (0, translate_1.fat)("出力フォーマット一覧の読み込みに失敗しました。"),
        format: (0, translate_1.fat)("出力フォーマットの読み込みに失敗しました。"),
        formatPs: (0, translate_1.fat)("出力フォーマットの読み込みに失敗しました。"),
        formatTemplateList: (0, translate_1.fat)("出力フォーマットテンプレート一覧の読み込みに失敗しました。"),
        formatTemplate: (0, translate_1.fat)("出力フォーマットテンプレートの読み込みに失敗しました。"),
        jobList: (0, translate_1.fat)("ジョブ一覧の読み込みに失敗しました。"),
        job: (0, translate_1.fat)("ジョブの読み込みに失敗しました。"),
        jobLogList: (0, translate_1.fat)("ジョブ実行ログ一覧の読み込みに失敗しました。"),
        jobLog: (0, translate_1.fat)("ジョブ実行ログの読み込みに失敗しました。"),
        loginLog: (0, translate_1.fat)("ログイン履歴の読み込みに失敗しました。"),
        list: (0, translate_1.fat)("Concurリストの取得に失敗しました。"),
        master: (0, translate_1.fat)("マスタ一覧の読み込みに失敗しました。"),
        master2: (0, translate_1.fat)("マスタ一覧の読み込みに失敗しました。"),
        modificationList: (0, translate_1.fat)("補正方法一覧の読み込みに失敗しました。"),
        modification: (0, translate_1.fat)("補正方法の読み込みに失敗しました。"),
        partnerList: (0, translate_1.fat)("取引先一覧の読み込みに失敗しました。"),
        partner: (0, translate_1.fat)("取引先の読み込みに失敗しました。"),
        accountingTypeList: (0, translate_1.fat)("勘定科目一覧の読み込みに失敗しました。"),
        accountingType: (0, translate_1.fat)("勘定科目の読み込みに失敗しました。"),
        taxDivList: (0, translate_1.fat)("税区分一覧の読み込みに失敗しました。"),
        taxDiv: (0, translate_1.fat)("税区分の読み込みに失敗しました。"),
        recipientList: (0, translate_1.fat)("宛名一覧の読み込みに失敗しました。"),
        recipient: (0, translate_1.fat)("宛名の読み込みに失敗しました。"),
        ipRestrictionList: (0, translate_1.fat)("IP制限一覧の読み込みに失敗しました。"),
        roleList: (0, translate_1.fat)("ロール一覧の読み込みに失敗しました。"),
        role: (0, translate_1.fat)("ロールの読み込みに失敗しました。"),
        ruleList: (0, translate_1.fat)("ルール一覧の読み込みに失敗しました。"),
        userList: (0, translate_1.fat)("ユーザー一覧の読み込みに失敗しました。"),
        user: (0, translate_1.fat)("ユーザーの読み込みに失敗しました。"),
        userMapping: (0, translate_1.fat)("ユーザ情報の読み込みに失敗しました。"),
        voucherList: (0, translate_1.fat)("証憑一覧の読み込みに失敗しました。"),
        voucher: (0, translate_1.fat)("証憑の読み込みに失敗しました。"),
        enabledAccountingTypeField: (0, translate_1.fat)("勘定科目項目の読み込みに失敗しました。"),
    };
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? false : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? loadSuccessMsgs["".concat(module)] || "" : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? loadFailureMsgs["".concat(module)] || "" : _e;
    var _f = __read((0, react_i18next_1.useTranslation)(), 1), t = _f[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res) {
        if (notifyOnSuccess) {
            notify({ message: (0, exports.buildMessage)(t, notificationSuccessKey), severity: "success" });
        }
        return (0, multi_1.setItems)(module, [res]);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, t]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: (0, exports.buildMessage)(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var item = state[0].itemMap[id];
    if (!id)
        url = "INVALID";
    var status = (0, loading_1.useHttpGet)(state[1], url, (0, util_1.omitUndefined)({ t: state[0].resetAt }), item === undefined, resultToAction, errorToAction);
    return (0, react_1.useMemo)(function () { return [item || state[0].headerMap[id], status]; }, [id, item, state, status]);
};
exports.useLoad = useLoad;
/**
 * 作成を使用する。
 * 型パラメータは Module, Header, Item, Body
 */
var useCreate = function (module, state, url, option) {
    var successMsgs = {
        user: (0, translate_1.fat)("ユーザーを作成しました。"),
        inputJob: (0, translate_1.fat)("CSV設定を登録しました。"),
    };
    var failureMsgs = {
        user: (0, translate_1.fat)("ユーザーの作成に失敗しました。"),
        inputJob: (0, translate_1.fat)("CSV設定の登録に失敗しました。"),
    };
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? successMsgs["".concat(module)] || "".concat(module, ".create.success") : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? failureMsgs["".concat(module)] || "".concat(module, ".create.failure") : _e;
    var _f = __read((0, react_i18next_1.useTranslation)(), 1), t = _f[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res) {
        if (notifyOnSuccess) {
            notify({ message: (0, exports.buildMessage)(t, notificationSuccessKey), severity: "success" });
        }
        return (0, multi_1.addItem)(module, res);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, t]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: (0, exports.buildMessage)(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var _g = __read((0, loading_1.useHttpPostBody)(state[1], url, resultToAction, errorToAction), 2), run = _g[0], status = _g[1];
    var newItems = state[0].newItems;
    var newItem = newItems.length === 0 ? undefined : newItems[newItems.length - 1];
    return (0, react_1.useMemo)(function () { return [run, status, newItem]; }, [newItem, run, status]);
};
exports.useCreate = useCreate;
var usePrepend = function (module) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var prepend = (0, react_1.useCallback)(function (item, queryHash) {
        dispatch((0, action_1.prependItem)(module, item, queryHash));
    }, [module, dispatch]);
    return prepend;
};
exports.usePrepend = usePrepend;
var useSetHeader = function (module) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var setHeader = (0, react_1.useCallback)(function (item) {
        dispatch((0, action_1.setHeaderItems)(module, [item]));
    }, [module, dispatch]);
    return setHeader;
};
exports.useSetHeader = useSetHeader;
/**
 * 編集を使用する。
 * 型パラメータは Module, Header, Item
 */
var useEdit = function (module) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var edit = (0, react_1.useCallback)(function (item) {
        dispatch((0, multi_1.setItems)(module, [item]));
    }, [module, dispatch]);
    return edit;
};
exports.useEdit = useEdit;
/**
 * 更新を使用する。
 * 型パラメータは Module, Header, Item, Body
 */
var useUpdate = function (module, state, url, option) {
    var loadSuccessMsgs = {
        inbox: (0, translate_1.fat)("読取を開始しました。"),
        tenant: (0, translate_1.fat)("テナントを更新しました。"),
        profile: (0, translate_1.fat)("プロフィールを更新しました。"),
        enabledVoucherField: (0, translate_1.fat)("証憑項目を更新しました。"),
        format: (0, translate_1.fat)("出力フォーマットを更新しました。"),
        job: (0, translate_1.fat)("ジョブを更新しました。"),
        modification: (0, translate_1.fat)("補正方法を更新しました。"),
        express: (0, translate_1.fat)("Expressの設定を更新しました。"),
        partner: (0, translate_1.fat)("取引先を更新しました。"),
        accountingType: (0, translate_1.fat)("勘定科目を更新しました。"),
        approvalRole: (0, translate_1.fat)("承認権限を更新しました。"),
        approvalStep: (0, translate_1.fat)("承認ステップを更新しました。"),
        taxDiv: (0, translate_1.fat)("税区分を更新しました。"),
        recipient: (0, translate_1.fat)("宛名を更新しました。"),
        ipRestriction: (0, translate_1.fat)("IP制限を更新しました。"),
        role: (0, translate_1.fat)("ロールを更新しました。"),
        user: (0, translate_1.fat)("ユーザーを更新しました。"),
        userMapping: (0, translate_1.fat)("ユーザ情報を更新しました。"),
        masterFormat: (0, translate_1.fat)("マスタフォーマットを更新しました。"),
        voucher: (0, translate_1.fat)("証憑を更新しました。"),
        externalMapping: (0, translate_1.fat)("外部マスタマッピングを更新しました。"),
        rule: (0, translate_1.fat)("ルールを更新しました。"),
        department: (0, translate_1.fat)("部門を更新しました。"),
        inputJob: (0, translate_1.fat)("CSV設定を更新しました。"),
        distribution: (0, translate_1.fat)("読取を開始しました。"),
        voucherMapping: (0, translate_1.fat)("入力設定を更新しました。"),
        filtering: (0, translate_1.fat)("絞込設定を更新しました。"),
        enabledPartnerField: (0, translate_1.fat)("取引先項目を更新しました。"),
        enabledAccountingTypeField: (0, translate_1.fat)("勘定科目項目を更新しました。"),
    };
    var loadFailureMsgs = {
        inbox: (0, translate_1.fat)("読取の開始に失敗しました。"),
        tenant: (0, translate_1.fat)("テナントの更新に失敗しました。"),
        profile: (0, translate_1.fat)("プロフィールの更新に失敗しました。"),
        enabledVoucherField: (0, translate_1.fat)("証憑項目の更新に失敗しました。"),
        format: (0, translate_1.fat)("出力フォーマットの更新に失敗しました。"),
        job: (0, translate_1.fat)("ジョブの更新に失敗しました。"),
        modification: (0, translate_1.fat)("補正方法の更新に失敗しました。"),
        express: (0, translate_1.fat)("Expressの設定を更新に失敗しました。"),
        partner: (0, translate_1.fat)("取引先の更新に失敗しました。"),
        accountingType: (0, translate_1.fat)("勘定科目の更新に失敗しました。"),
        approvalRole: (0, translate_1.fat)("承認権限の更新に失敗しました。"),
        approvalStep: (0, translate_1.fat)("承認ステップの更新に失敗しました。"),
        taxDiv: (0, translate_1.fat)("税区分の更新に失敗しました。"),
        recipient: (0, translate_1.fat)("宛名の更新に失敗しました。"),
        ipRestriction: (0, translate_1.fat)("IP制限の更新に失敗しました。"),
        role: (0, translate_1.fat)("ロールの更新に失敗しました。"),
        user: (0, translate_1.fat)("ユーザーの更新に失敗しました。"),
        userMapping: (0, translate_1.fat)("ユーザ情報の更新に失敗しました。"),
        masterFormat: (0, translate_1.fat)("マスタフォーマットの更新に失敗しました。"),
        voucher: (0, translate_1.fat)("証憑の更新に失敗しました。"),
        externalMapping: (0, translate_1.fat)("外部マスタマッピングの更新に失敗しました。"),
        rule: (0, translate_1.fat)("ルールの更新に失敗しました。"),
        department: (0, translate_1.fat)("部門の更新に失敗しました。"),
        inputJob: (0, translate_1.fat)("CSV設定の更新に失敗しました。"),
        distribution: (0, translate_1.fat)("読取の開始に失敗しました。"),
        voucherMapping: (0, translate_1.fat)("入力設定の更新に失敗しました。"),
        filtering: (0, translate_1.fat)("絞込設定の更新に失敗しました。"),
        enabledPartnerField: (0, translate_1.fat)("取引先項目の更新に失敗しました。"),
        enabledAccountingTypeField: (0, translate_1.fat)("勘定科目項目の更新に失敗しました。"),
    };
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? loadSuccessMsgs["".concat(module)] || "" : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? loadFailureMsgs["".concat(module)] || "" : _e, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
    var _f = __read((0, react_i18next_1.useTranslation)(), 1), t = _f[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res, req) {
        if (notifyOnSuccess) {
            notify({ message: (0, exports.buildMessage)(t, notificationSuccessKey), severity: "success" });
        }
        if (onSuccess) {
            onSuccess(res, req);
        }
        return (0, multi_1.setItems)(module, [res]);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, onSuccess, t]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: (0, exports.buildMessage)(t, notificationFailureKey, e.message), severity: "error" });
        }
        if (onFailure) {
            onFailure(e);
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, onFailure, t]);
    return (0, loading_1.useHttpPutBody)(state, url, resultToAction, errorToAction);
};
exports.useUpdate = useUpdate;
/**
 * 一括更新を使用する。
 * 型パラメータは Module, Header, Item, Body
 */
var useUpdateBulk = function (module, state, url, option) {
    var loadSuccessMsgs = {
        externalMapping: (0, translate_1.fat)("外部マスタマッピングを更新しました。"),
        rule: (0, translate_1.fat)("ルールを更新しました。"),
        userMapping: (0, translate_1.fat)("ユーザ情報を更新しました。"),
        voucher: (0, translate_1.fat)("証憑を一括更新しました。"),
        approvalRoute: (0, translate_1.fat)("承認ルートを更新しました。"),
    };
    var loadFailureMsgs = {
        externalMapping: (0, translate_1.fat)("外部マスタマッピングの更新に失敗しました。"),
        rule: (0, translate_1.fat)("ルールの更新に失敗しました。"),
        userMapping: (0, translate_1.fat)("ユーザ情報の更新に失敗しました。"),
        voucher: (0, translate_1.fat)("証憑の一括更新に失敗しました。"),
        approvalRoute: (0, translate_1.fat)("承認ルートの更新に失敗しました。"),
    };
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? loadSuccessMsgs["".concat(module)] || "" : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? loadFailureMsgs["".concat(module)] || "" : _e, onSuccess = _a.onSuccess;
    var _f = __read((0, react_i18next_1.useTranslation)(), 1), t = _f[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function (res, req) {
        if (notifyOnSuccess) {
            notify({ message: (0, exports.buildMessage)(t, notificationSuccessKey), severity: "success" });
        }
        if (onSuccess) {
            onSuccess(res, req);
        }
        return (0, multi_1.setItems)(module, res);
    }, [module, notificationSuccessKey, notify, notifyOnSuccess, t, onSuccess]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: (0, exports.buildMessage)(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    return (0, loading_1.useHttpPutBody)(state, url, resultToAction, errorToAction);
};
exports.useUpdateBulk = useUpdateBulk;
/**
 * 削除を使用する。
 * 型パラメータは Module
 */
var useDelete = function (module, state, url, id, option) {
    var failureMsgs = {
        enabledVoucherField: (0, translate_1.fat)("証憑項目の削除に失敗しました。"),
        format: (0, translate_1.fat)("出力フォーマットの削除に失敗しました。"),
        job: (0, translate_1.fat)("ジョブの削除に失敗しました。"),
        modification: (0, translate_1.fat)("補正方法の削除に失敗しました。"),
        express: (0, translate_1.fat)("Expressの設定を削除に失敗しました。"),
        partner: (0, translate_1.fat)("取引先の削除に失敗しました。"),
        accountingType: (0, translate_1.fat)("勘定科目の削除に失敗しました。"),
        approvalRole: (0, translate_1.fat)("承認権限の削除に失敗しました。"),
        approvalStep: (0, translate_1.fat)("承認ステップの削除に失敗しました。"),
        taxDiv: (0, translate_1.fat)("税区分の削除に失敗しました。"),
        recipient: (0, translate_1.fat)("宛名の削除に失敗しました。"),
        ipRestriction: (0, translate_1.fat)("IP制限の削除に失敗しました。"),
        voucher: (0, translate_1.fat)("証憑の削除に失敗しました。"),
        voucherAttachment: (0, translate_1.fat)("添付ファイルの削除に失敗しました。"),
        department: (0, translate_1.fat)("部門の削除に失敗しました。"),
        inputJob: (0, translate_1.fat)("入力ジョブの削除に失敗しました。"),
        enabledAccountingTypeField: (0, translate_1.fat)("勘定科目項目の削除に失敗しました。"),
    };
    var successMsgs = {
        enabledVoucherField: (0, translate_1.fat)("証憑項目を削除しました。"),
        format: (0, translate_1.fat)("出力フォーマットを削除しました。"),
        job: (0, translate_1.fat)("ジョブを削除しました。"),
        modification: (0, translate_1.fat)("補正方法を削除しました。"),
        express: (0, translate_1.fat)("Expressの設定を削除しました。"),
        partner: (0, translate_1.fat)("取引先を削除しました。"),
        accountingType: (0, translate_1.fat)("勘定科目を削除しました。"),
        approvalRole: (0, translate_1.fat)("承認権限を削除しました。"),
        approvalStep: (0, translate_1.fat)("承認ステップを削除しました。"),
        taxDiv: (0, translate_1.fat)("税区分を削除しました。"),
        recipient: (0, translate_1.fat)("宛名を削除しました。"),
        ipRestriction: (0, translate_1.fat)("IP制限を削除しました。"),
        voucher: (0, translate_1.fat)("証憑を削除しました。"),
        voucherAttachment: (0, translate_1.fat)("添付ファイルを削除しました。"),
        department: (0, translate_1.fat)("部門を削除しました。"),
        inputJob: (0, translate_1.fat)("入力ジョブを削除しました。"),
        apiToken: (0, translate_1.fat)("トークンを削除しました。"),
        enabledAccountingTypeField: (0, translate_1.fat)("勘定科目項目を削除しました。"),
    };
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? successMsgs["".concat(module)] || "" : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? failureMsgs["".concat(module)] || "" : _e;
    var _f = __read((0, react_1.useState)(false), 2), running = _f[0], setRunning = _f[1];
    var _g = __read((0, react_i18next_1.useTranslation)(), 1), t = _g[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function () {
        if (notifyOnSuccess) {
            notify({ message: (0, exports.buildMessage)(t, notificationSuccessKey), severity: "success" });
        }
        setRunning(false);
        return (0, multi_1.deleteItems)(module, [id]);
    }, [notifyOnSuccess, module, id, notify, t, notificationSuccessKey]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: (0, exports.buildMessage)(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var status = (0, loading_1.useHttpDelete)(state, url, running, resultToAction, errorToAction);
    var run = (0, react_1.useCallback)(function () {
        setRunning(true);
    }, [setRunning]);
    return (0, react_1.useMemo)(function () { return [run, status]; }, [run, status]);
};
exports.useDelete = useDelete;
/**
 * 削除を使用する。
 * 型パラメータは Module
 */
var useDeleteBulk = function (module, state, url, option) {
    var loadSuccessMsgs = {
        voucher: (0, translate_1.fat)("証憑を一括削除しました。"),
    };
    var loadFailureMsgs = {
        voucher: (0, translate_1.fat)("証憑の一括削除に失敗しました。"),
    };
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? loadSuccessMsgs["".concat(module)] || "" : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? loadFailureMsgs["".concat(module)] || "" : _e;
    var _f = __read((0, react_1.useState)([]), 2), ids = _f[0], setIds = _f[1];
    var _g = __read((0, react_i18next_1.useTranslation)(), 1), t = _g[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function () {
        if (notifyOnSuccess) {
            notify({ message: (0, exports.buildMessage)(t, notificationSuccessKey), severity: "success" });
        }
        setIds([]);
        return (0, multi_1.deleteItems)(module, ids);
    }, [notifyOnSuccess, module, ids, notify, t, notificationSuccessKey]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: (0, exports.buildMessage)(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var status = (0, loading_1.useHttpPost)(state, url, ids, ids.length > 0, resultToAction, errorToAction);
    var run = (0, react_1.useCallback)(function (ids) {
        setIds(ids);
    }, [setIds]);
    return (0, react_1.useMemo)(function () { return [run, status]; }, [run, status]);
};
exports.useDeleteBulk = useDeleteBulk;
var useFileUpload = function (module, state, url, option) {
    var loadSuccessMsgs = {
        partner: (0, translate_1.fat)("取引先のアップロードを開始しました。"),
    };
    var loadFailureMsgs = {
        partner: (0, translate_1.fat)("取引先のアップロードの開始に失敗しました。"),
    };
    var _a = option || {}, _b = _a.notifyOnSuccess, notifyOnSuccess = _b === void 0 ? true : _b, _c = _a.notificationSuccessKey, notificationSuccessKey = _c === void 0 ? loadSuccessMsgs["".concat(module)] || "" : _c, _d = _a.notifyOnFailure, notifyOnFailure = _d === void 0 ? true : _d, _e = _a.notificationFailureKey, notificationFailureKey = _e === void 0 ? loadFailureMsgs["".concat(module)] || "" : _e;
    var _f = __read((0, react_1.useState)(null), 2), file = _f[0], setFile = _f[1];
    var _g = __read((0, react_i18next_1.useTranslation)(), 1), t = _g[0];
    var notify = (0, notification_1.useNotify)();
    var resultToAction = (0, react_1.useCallback)(function () {
        if (notifyOnSuccess) {
            notify({ message: (0, exports.buildMessage)(t, notificationSuccessKey), severity: "success" });
        }
        setFile(null);
    }, [notifyOnSuccess, notify, t, notificationSuccessKey]);
    var errorToAction = (0, react_1.useCallback)(function (e) {
        if (notifyOnFailure) {
            notify({ message: (0, exports.buildMessage)(t, notificationFailureKey, e.message), severity: "error" });
        }
        return undefined;
    }, [notificationFailureKey, notify, notifyOnFailure, t]);
    var form = (0, react_1.useMemo)(function () {
        if (!file) {
            return null;
        }
        var form = new FormData();
        form.append("file", file);
        return form;
    }, [file]);
    var status = (0, loading_1.useHttpPostForm)(state, url, form, form !== null, resultToAction, errorToAction);
    var run = (0, react_1.useCallback)(function (file) {
        setFile(file);
    }, [setFile]);
    return (0, react_1.useMemo)(function () { return [run, status]; }, [run, status]);
};
exports.useFileUpload = useFileUpload;
